import { PriceItxDto } from "src/api/customer";

export const ERRORS_ASK_FOR_DETAILS = {
  MINPRICE: "ask_for_details_error_not_valid_offer_price",
  MAXPRICE: "ask_for_details_error_not_valid_max_offer_price",
  REQUIRED_PRICE: "ask_for_details_error_required_offer_price",
  REQUIRED_IMAGES: "ask_for_details_error_not-selected-sub-detail",
} as const;

export type ErrorsVariantsAFD =
  (typeof ERRORS_ASK_FOR_DETAILS)[keyof typeof ERRORS_ASK_FOR_DETAILS];

export interface AskForDetailsLiterals {
  button: string;
  description: string;
  title: string;
}

export interface AskForDetailsProps {
  literals?: AskForDetailsLiterals;
  anyQuestionSelected?: boolean;
  onSubmitQuestions?: () => void;
}

export interface AksForDetailsAlert {
  show: boolean;
  title: string;
  description: string;
  acceptButton: string;
  cancelButton: string;
  onAccept: () => void;
  onCancel: () => void;
}

export interface AFDQuestions {
  code?: string;
  title?: string;
  selected?: boolean;
}

export interface AFDCategories {
  code?: string;
  title?: string;
  questions?: Array<AFDQuestions>;
  enabled?: boolean;
  offerInput?: PriceItxDto;
  errorText?: string;
  selected?: boolean;
  isValid?: boolean;
  warningHighPriority?: boolean;
}

export interface NotValidQuestions {
  updatedCategories: AFDCategories[];
  invalidQuestionsCount: number;
  errorInputPrice: string | null;
}

export interface OfferPriceAskForDetailsProps {
  questionOfferPrice?: AFDCategories;
  index?: number;
}
